import React from "react";
import {
  Box,
  Card,
  CardContent,
  Button,
  makeStyles,
  CardMedia,
  List,
  ListItem,
  Typography,
  Divider,
  ListItemIcon,
  Grid,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord"; // Bullet point icon
import "../styles/cardComponent.css";
import CloseIcon from '@mui/icons-material/Close';


const DynamicCard = ({ payment,imageData, bulletPoints = [], onButtonClick, onButtonClick1, onDeleteButton, dealid, startUpId, num, resource }) => {
  if (num === 2) {
    bulletPoints = ['Lorem ipsum dolor sit amet consectetur.', 'Lorem ipsum dolor sit amet consectetur.', 'Lorem ipsum dolor sit amet consectetur.']

  } else {
    const parser = new DOMParser();
    if (resource?.shortDescription) {
      bulletPoints = resource?.shortDescription.split(".")

    }
    else {
      bulletPoints = []
    }
  }


  return (
    <Card className='cardContainer' >
      <Box sx={{display:"flex", justifyContent:"space-between"}}>
      <Box className="cardComponentWidth" onClick={() => onButtonClick(dealid, startUpId)} sx={{display: "flex", justifyContent: "space-between", width: "90%", gap: "40px", cursor:"pointer" }}>
        <Box sx={{ minHeight: "60px", maxHeight: "60px", paddingBottom: "10px", }}>
          <img
            style={{ borderRadius: "10px" }}
            component="img"
            height="auto"
            image={imageData}
            alt="Card Image"
            src={imageData ?? "https://upload.wikimedia.org/wikipedia/commons/b/bf/Incred-logo.jpg"}
          />
        </Box>
        </Box>
        {num === 1 ? <>
          <Box sx={{ backgroundColor: "black", height: "25px", borderRadius: "8px", color: "white", }}
            
          >
            <CloseIcon style={{ cursor: "pointer" }} onClick={() => onDeleteButton(startUpId)}/>
          </Box>
        </> : <></>}
      
      </Box>
      <Typography color="#b6b4b4">{resource?.dealName?.length > 32 ? resource?.dealName?.substring(0, 32) + "..." : resource?.dealName}</Typography>
      <Divider className='divider'></Divider>
      <CardContent className="cardContent1">
        <List>
          {bulletPoints.map((point, index) => (
            <ListItem className='listingItems' key={index}>
              <Typography color="#b6b4b4">&bull; {point}</Typography>
            </ListItem>
          ))}
        </List>
      </CardContent>
      {num === 1 ? (
        <>
          <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "10px" }}>
            <Button
              className="investButton1"
              onClick={() => onButtonClick(dealid, startUpId)}
            >
              Read More
            </Button>

            <Button
              className="investButton2"
              onClick={() => onButtonClick1(num === 1 ? startUpId : dealid)}
              sx={{ flex: 1 }}
            >
             {payment ? "Select Timeslot" :  "Pay" }
            </Button>
          </Box>
        </>
      ) : (
        <Button className="investButton" onClick={() => onButtonClick(dealid, startUpId)}>
          Invest now
        </Button>
      )}
    </Card>
  );
};

export default DynamicCard;
